import { FunctionComponent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Dialog from '@/components/_custom/Dialog/Dialog'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import styles from './addEventsClosingDays.module.scss'
import EditEventDay from '../eventDay/Dialog/editEventDay/editEventDay.tsx'
import { Daycare, DaycareType } from '@/types/Daycare'
import EditClosingDay from '../closingDay/Dialog/editClosingDay'
import { ClosingDay } from '@/types/ClosingDays'
import moment from 'moment-timezone'

interface AddClosingDaysDialogProps {
    open: boolean
    handleClose: () => void
    daycareId: number
    daycareType?: DaycareType
    daycare?: Daycare
    closingDays?: ClosingDay[]
    refetchAllEvents: () => Promise<void>
}

const AddEventsClosingDaysDialog: FunctionComponent<AddClosingDaysDialogProps> = ({
    open,
    handleClose,
    daycareId,
    daycareType,
    refetchAllEvents,
    closingDays
}: AddClosingDaysDialogProps) => {
    const { t } = useTranslation()

    const [isClosingDay, setIsClosingDay] = useState<boolean>(false)
    const [title, setTitle] = useState<string>('')
    const [date, setDate] = useState<string>(moment().format('DD-MM-YYYY'))

    return (
        <Dialog open={open} handleClose={handleClose}>
            <DialogHeader title={isClosingDay ? t('addClosingDay') : t('addEventDay')} />
            <DialogBody className={styles.DialogBody}>
                {isClosingDay ? (
                    <EditClosingDay
                        create={true}
                        daycareId={daycareId}
                        handleClose={handleClose}
                        refetchAllEvents={refetchAllEvents}
                        setIsClosingDay={setIsClosingDay}
                        setTitle={setTitle}
                        title={title}
                        dateStart={date}
                        setDateStart={setDate}
                        isClosingDay={isClosingDay}
                        closingDays={closingDays}
                    />
                ) : (
                    <EditEventDay
                        create={true}
                        daycareId={daycareId}
                        daycareType={daycareType}
                        handleClose={handleClose}
                        refetchAllEvents={refetchAllEvents}
                        setIsClosingDay={setIsClosingDay}
                        setTitle={setTitle}
                        title={title}
                        date={date}
                        setDate={setDate}
                        isClosingDay={isClosingDay}
                    />
                )}
            </DialogBody>
        </Dialog>
    )
}

export default AddEventsClosingDaysDialog
